import Type from './Type'
import Data from './Data'
import Address from './Address'
import Summary from './Summary'
import Finish from './Finish'

export default {
  Type,
  Data,
  Address,
  Summary,
  Finish,
}
